import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class NacinpredavanjaPopisService {

  constructor(private _http: Http) { }

  dohvatiSve(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_nacinepredavanja', a)
    .map(res => res.json());
  }

  dodajNacinpredavanja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'spremi_nacinpredavanja', a)
    .map(res => res.json());
  }

  urediNacinpredavanja(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'uredi_nacinpredavanja', a)
    .map(res => res.json());
  }

  obrisiNacinpredavanja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'obrisi_nacinpredavanja', a)
    .map(res => res.json());
  }


}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/nacinpredavanja-popis/nacinpredavanja-popis.service.ts